import React from 'react'
import { motion } from 'framer-motion'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
  className?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  text,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  }

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        className={`${sizeClasses[size]} border-[3px] border-cream-300 dark:border-ink-500 border-t-terra-500 dark:border-t-terra-300 rounded-full`}
      />
      {text && (
        <p className="mt-3 text-ink-500 dark:text-ink-300 text-[13px]">{text}</p>
      )}
    </div>
  )
}

export default LoadingSpinner